import { canonicalPagePath, SITE_URL } from './pageMetadata.ts'

const PUBLIC_HOSTS = new Set(['www.omikina.com', 'omikina.com'])
const CAMPAIGN_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_id']

export function analyticsAllowedUrl(input: string): boolean {
  try {
    const url = new URL(input)
    return url.protocol === 'https:' && PUBLIC_HOSTS.has(url.hostname)
      && !/^\/(?:admin|newsletter|api)(?:\/|$)/.test(url.pathname)
      && !['capture', 'seo-check', 'analytics_off'].some((key) => url.searchParams.has(key))
  } catch { return false }
}

// Keep landing pages joinable to Search Console's canonical URLs. Only bounded
// campaign labels survive; queries, tokens, fragments and search text never do.
export function analyticsPageContext(input: string) {
  const url = new URL(input, SITE_URL)
  const path = canonicalPagePath(url.pathname, url.search)
  const canonical = `${SITE_URL}${path}`
  const location = new URL(canonical)
  for (const key of CAMPAIGN_KEYS) {
    const value = url.searchParams.get(key)
    if (value && /^[a-zA-Z0-9_-]{1,100}$/.test(value)) location.searchParams.set(key, value)
  }
  return {
    page_path: path,
    page_location: location.href,
    canonical_url: canonical,
    content_group: path === '/' ? 'home'
      : path.startsWith('/article/') || path === '/articles' ? 'articles'
      : path.startsWith('/intelligence/state-of-ai') ? 'state_of_ai'
      : path.startsWith('/briefing/') || path === '/intelligence' ? 'daily_briefing'
      : path.startsWith('/news') ? 'news'
      : /^\/(company|companies|country|world|topic|industry|industries|infrastructure|us)(\/|$)/.test(path) ? 'research'
      : /^\/(research|sponsor|work-with-omikina|media-kit|scope-builder|shop)(\/|$)/.test(path) ? 'commercial'
      : 'reader_resources',
  }
}

export function analyticsReferrer(input: string): string {
  if (!input) return ''
  try {
    const url = new URL(input)
    if (!['http:', 'https:'].includes(url.protocol)) return ''
    return PUBLIC_HOSTS.has(url.hostname) ? analyticsPageContext(input).canonical_url : url.origin + '/'
  } catch { return '' }
}
